import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class AsnOrders_ds_get_order_by_orderId_detailedService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { orderId: number }): 
  Promise<{ result: { Id?: number, OrderStatusId?: number, ProjectId?: number, OrderLines?: { LineNumber?: number, StatusId?: number }[], ShipmentOrderLookups?: { ShipmentId?: number, Shipment?: { Id?: number, StatusId?: number, ShipmentLines?: { Id?: number, StatusId?: number }[], ActualWarehouse?: { Id?: number, DefaultAsnReceivingLocationId?: number, DefaultReceivingLocationId?: number, Name?: string }, ExpectedWarehouse?: { Id?: number, DefaultAsnReceivingLocationId?: number, DefaultReceivingLocationId?: number, Name?: string } } }[] } }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.orderId)) {
      missingRequiredInParams.push('\'orderId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/AsnOrders/datasources/ds_get_order_by_orderId_detailed/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      orderId: number    }) {
        if(isNil(inParams.orderId)) {
          return true; 
        }
      return false;
    }
}
